export default "__VITE_ASSET__Cc5W3Ula__"